// material-ui
import { Grid, Typography, Stack, Link } from '@mui/material';

// project imports
import MainCard from 'components/cards/MainCard';
import Main from 'views/layouts/Main/Main'; //
import { SimSection, SimSectionHeader, StaticSectionWrapper } from 'components/StaticSections';

const TermsAndConditions = () => {
	return (
		<Main>
			<StaticSectionWrapper>
				<Grid container justifyContent='center' spacing={1}>
					<SimSectionHeader title='Terms And Conditions' />
					<Grid item xs={12}>
						<MainCard elevation={4} border={false} boxShadow shadow={4} sx={{ mb: 3 }}>
							<Stack spacing={2} sx={{ textAlign: 'left' }}>
								<SimSection>
									<Typography textAlign={'justify'}>
										Please read the following Terms of Use (“Terms”) carefully. They govern your use
										of both Sim Souls Group LLC’s and SIM SOULS INSTITUTE 1 INC’s (“SimSouls”, “we”
										or “us”) website at{' '}
										<Link href='www.simsouls.com' underline='none' sx={{ py: 1 }}>
											www.simsouls.com
										</Link>{' '}
										(the “Website”). By using the Website, you acknowledge that you have read and
										understand all the Terms, and you agree to be bound and abide by these Terms and
										our Privacy Policy, found at{' '}
										<Link href='www.simsouls.com' underline='none' sx={{ py: 1 }}>
											https://www.simsouls.com/privacy
										</Link>{' '}
										and incorporated herein by reference. If you do not agree to these Terms, please
										do not access, or use the Website. Your use of the Website shall constitute
										consent to these Terms.
									</Typography>
								</SimSection>

								<SimSection title='I. NATURE OF THE WEBSITE'>
									<Typography textAlign={'justify'}>
										The Website is an online source of information about health conditions, health
										care procedures, health care providers, and other topics. Information provided
										through the Website is not intended to be a substitute for the advice and
										professional judgment of physician or other professional medical personnel. You
										acknowledge and agree that you should never delay treatment or make a treatment
										decision based solely upon information provided through the Website. You further
										acknowledge and agree that the Website is not intended to diagnose a condition,
										prescribe treatment, or perform any other tasks that constitute or may
										constitute the practice of medicine or of other professional or academic
										disciplines. We work diligently to provide information that is current, timely,
										and useful. However, SimSouls cannot and does not warrant that any of this
										information is always accurate and complete. Any reliance you place on such
										Website information is strictly at your own risk.
									</Typography>
								</SimSection>

								<SimSection title='II. USE OF THE WEBSITE'>
									<Typography textAlign={'justify'}>
										You may use the Website only for legal, personal, non-commercial (not for
										profit) uses in accordance with these Terms. SimSouls reserves the right to make
										changes to, update or withdraw the Website at any time and without notice. Your
										access to and use of the Website is completely at the discretion of SimSouls,
										and your access to and use of all or part of the Website may be blocked,
										suspended, or terminated should your use violate these Terms. You may link a
										website or webpage to the Website, provided you do so in a way that is fair and
										legal and does not damage our reputation or imply SimSouls’s endorsement of any
										such use.
									</Typography>
								</SimSection>

								<SimSection title='III. INTELLECTUAL PROPERTY'>
									<Typography textAlign={'justify'}>
										The Website and its entire contents, features, and functionality (including but
										not limited to all information, software, text, displays, images, video, and
										audio, and the design, selection, and arrangement thereof), are owned by
										SimSouls, its licensors, or other providers of such material and may be
										protected by United States and international copyright, trademark, patent, trade
										secret, and other intellectual property or proprietary rights laws. SimSouls®
										and SimSouls ParentEd® are subject to a pending application for federal
										registration as a trademark of SimSouls. You must not use such marks without the
										prior express written consent of SimSouls. All other names, logos, products and
										service names, designs, and slogans on this Website are the trademarks or
										property of their respective owners. Except as otherwise permitted by these
										Terms, you may not download, modify, make derivative works of, store or transmit
										any material on the Website, or any portion of the Website, except with express
										written consent of SimSouls. You may view, print, copy, and download portions of
										information, documentation, and other content of the Website solely in
										connection with your use of the Website, and solely for your own personal,
										non-commercial (not for profit) use or personal records. No right, title, or
										interest in or to the Website or any content on the Website is transferred to
										you, and all rights not expressly granted are reserved by SimSouls. Any use of
										the Website not expressly permitted by these Terms is a breach of these Terms
										and may violate copyright, trademark, contract, and other laws.
									</Typography>
								</SimSection>

								<SimSection title='IV. HIPAA'>
									<Typography textAlign={'justify'}>
										Please be advised that while SimSouls and its clinics, in certain capacities,
										are regulated by the Health Insurance Portability and Accountability Act
										(“HIPAA”), it is not the intent or designed purpose of the Website to collect,
										store or transfer Protected Health Information (“PHI”). Your use of the Website
										does not create a patient relationship between you and SimSouls, or between you
										and any health care professional employed by or associated with SimSouls. Any
										information you provide through the Website will not be considered a medical
										record or PHI. Please do not enter or share sensitive healthcare information,
										including PHI, into the Website. Please use traditional means already
										established with any healthcare providers under the appropriate Notice of
										Privacy Practices for that provider.
									</Typography>
								</SimSection>

								<SimSection title='V. THIRD PARTY INFORMATION; LINKS TO OTHER SITES'>
									<Typography textAlign={'justify'}>
										The Website may contain windows or hyperlinks which provide access to other
										third-party websites not affiliated with the Website or with SimSouls, or to
										informational content provided by such third-party websites. Any links to third
										party websites are for your convenience only. Your use of such third-party
										websites or information is subject to and governed by any terms of use and
										privacy policy posted on any such third-party website. SimSouls is not liable
										for and does not endorse nor make any representations or warranties concerning
										any information, content, products, services, software, or other materials
										available on such third-party websites, even if a page or pages of the
										third-party website is framed within a page of this Website.
									</Typography>
								</SimSection>

								<SimSection title='VI. DISCLAIMER OF WARRANTIES & LIMITATION OF LIABILITY'>
									<Typography textAlign={'justify'}>
										You understand the use of the Website is at your own risk. You understand that
										we cannot and do not guarantee or warrant that files available for downloading
										from the internet or the Website will be free of viruses or other destructive
										code. You are responsible for implementing sufficient procedures and checkpoints
										to satisfy your particular requirements for anti-virus protection and accuracy
										of data input and output, and for maintaining a means external to our site for
										any reconstruction of any lost data. WE WILL NOT BE LIABLE FOR ANY LOSS OR
										DAMAGE CAUSED BY A DISTRIBUTED DENIAL-OF-SERVICE ATTACK, VIRUSES OR OTHER
										TECHNOLOGICALLY HARMFUL MATERIAL THAT MAY INFECT YOUR COMPUTER EQUIPMENT,
										COMPUTER PROGRAMS, DATA OR OTHER PROPRIETARY MATERIAL DUE TO YOUR USE OF THE
										WEBSITE OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE OR TO YOUR
										DOWNLOADING OF ANY MATERIAL POSTED ON IT, OR ON ANY WEBSITE LINKED TO IT.
									</Typography>

									<Typography textAlign={'justify'}>
										THE WEBSITE, ITS CONTENT AND ANY SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE
										ARE PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS, WITHOUT ANY WARRANTIES OF
										ANY KIND, EITHER EXPRESS OR IMPLIED. NEITHER SIMSOULS NOR ANY PERSON ASSOCIATED
										WITH SIMSOULS MAKES ANY WARRANTY OR REPRESENTATION WITH RESPECT TO THE
										COMPLETENESS, SECURITY, RELIABILITY, QUALITY, ACCURACY OR AVAILABILITY OF THE
										WEBSITE. WITHOUT LIMITING THE FOREGOING, NEITHER SIMSOULS NOR ANYONE ASSOCIATED
										WITH SIMSOULS REPRESENTS OR WARRANTS THAT THE WEBSITE, ITS CONTENT OR ANY
										SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE WILL BE ACCURATE, RELIABLE,
										ERROR-FREE OR UNINTERRUPTED, THAT DEFECTS WILL BE CORRECTED, THAT OUR SITE OR
										THE SERVER THAT MAKES IT AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL
										COMPONENTS OR THAT THE WEBSITE OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE
										WEBSITE WILL OTHERWISE MEET YOUR NEEDS OR EXPECTATIONS. SIMSOULS HEREBY
										DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, STATUTORY OR
										OTHERWISE, INCLUDING BUT NOT LIMITED TO ANY WARRANTIES OF MERCHANTABILITY,
										NON-INFRINGEMENT AND FITNESS FOR PARTICULAR PURPOSE. IN NO EVENT WILL SIMSOULS,
										ITS AFFILIATES OR THEIR LICENSORS, SERVICE PROVIDERS, EMPLOYEES, AGENTS,
										OFFICERS OR DIRECTORS BE LIABLE FOR DAMAGES OF ANY KIND, UNDER ANY LEGAL THEORY,
										ARISING OUT OF OR IN CONNECTION WITH YOUR USE, OR INABILITY TO USE, THE WEBSITE,
										ANY WEBSITES LINKED TO IT, ANY CONTENT ON THE WEBSITE OR SUCH OTHER WEBSITES OR
										ANY SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE OR SUCH OTHER WEBSITES,
										INCLUDING ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL OR PUNITIVE
										DAMAGES, INCLUDING BUT NOT LIMITED TO, PERSONAL INJURY, PAIN AND SUFFERING,
										EMOTIONAL DISTRESS, LOSS OF REVENUE, LOSS OF PROFITS, LOSS OF BUSINESS OR
										ANTICIPATED SAVINGS, LOSS OF USE, LOSS OF GOODWILL, LOSS OF DATA, AND WHETHER
										CAUSED BY TORT (INCLUDING NEGLIGENCE), BREACH OF CONTRACT OR OTHERWISE, EVEN IF
										FORESEEABLE. THE FOREGOING DOES NOT AFFECT ANY WARRANTIES WHICH CANNOT BE
										EXCLUDED OR LIMITED UNDER APPLICABLE LAW.
									</Typography>
								</SimSection>

								<SimSection title='VII. GENERAL'>
									<SimSection title='A. INFORMATION YOU PROVIDE US'>
										<Typography textAlign={'justify'}>
											The laws of the State of Indiana shall govern these Terms. All matters
											relating to the Website and these Terms and any dispute or claim arising
											therefrom or related thereto (in each case, including non-contractual
											disputes or claims), shall be governed by and construed in accordance with
											the internal laws of the State of Indiana without giving effect to any
											choice or conflict of law provision or rule (whether of the State of Indiana
											or any other jurisdiction). Any legal suit, action or proceeding arising out
											of, or related to, these Terms or the Website shall be instituted
											exclusively in the federal courts of the United States or the courts of the
											State of Indiana in each case located in the City of Indianapolis and County
											of Marion. You waive any and all objections to the exercise of jurisdiction
											over you by such courts and to venue in such courts.
										</Typography>
									</SimSection>
									<SimSection title='B. ARBITRATION'>
										<Typography textAlign={'justify'}>
											At SimSouls’s sole discretion, SimSouls may require you to submit any
											disputes arising from the use of these Terms or the Website, including
											disputes arising from or concerning their interpretation, violation,
											invalidity, non-performance, or termination, to final and binding
											arbitration under the Rules of Arbitration of the American Arbitration
											Association applying Indiana law.
										</Typography>
									</SimSection>
									<SimSection title='C. INDEMNIFICATION'>
										<Typography textAlign={'justify'}>
											You agree to defend, indemnify and hold harmless SimSouls, its affiliates,
											licensors and service providers, and its and their respective officers,
											directors, employees, contractors, agents, licensors, suppliers, successors
											and assigns from and against any claims, liabilities, damages, judgments,
											awards, losses, costs, expenses or fees (including reasonable attorneys’
											fees) arising out of or relating to your violation of these Terms or your
											use of the Website, including, but not limited to any submissions you make,
											any use of the Website’s content, services and products other than as
											expressly authorized in these Terms or your use of any information obtained
											from the Website.
										</Typography>
									</SimSection>
									<SimSection title='D. U.S. USE ONLY'>
										<Typography textAlign={'justify'}>
											SimSouls, as the owner of the Website, is based in the state of Indiana in
											the United States. We provide this Website for use only by persons located
											in the United States.
										</Typography>
									</SimSection>
									<SimSection title='E. CHANGES'>
										<Typography textAlign={'justify'}>
											SimSouls reserves the right to change the Terms in its sole and absolute
											discretion at any time. All changes to the Terms are effective from the date
											posted.
										</Typography>
									</SimSection>
									<SimSection title='F. QUESTIONS OR COMMENTS'>
										<Typography textAlign={'justify'}>
											If you have any questions, comments or concerns about these Terms, the
											Website, or your dealings with SimSouls, please email your questions to
											Email Compliance at{' '}
											<Link href='#' underline='none'>
												contact@simsouls.com
											</Link>
											{'.'}
										</Typography>
									</SimSection>
								</SimSection>

								<SimSection title='VIII. CHANGES TO THE TERMS OF USE'>
									<Typography textAlign={'justify'}>
										The Company may change the Terms from time to time as required by evolving
										business needs. If changes are made, please note that it may take up to 30
										business days before new practices are implemented. The current revision date
										will always be designated within the Terms. Check this page periodically if you
										would like to monitor changes.
									</Typography>
								</SimSection>
							</Stack>
						</MainCard>
					</Grid>
				</Grid>
			</StaticSectionWrapper>
		</Main>
	);
};

export default TermsAndConditions;
